import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStripePaymentMethod implements BaseEnumType {
  private static allValues: EnumStripePaymentMethod[] = []; // make sure this is top-most
  
  public static card = new EnumStripePaymentMethod(0, "Card", "enum_stripe_payment_method_card");
  public static bacsDebit = new EnumStripePaymentMethod(1, "BacsDebit", "enum_stripe_payment_method_bacs_debit");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStripePaymentMethod.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCard() { return this === EnumStripePaymentMethod.card; }
  public isBacsDebit() { return this === EnumStripePaymentMethod.bacsDebit; }

  public static getValues(): readonly EnumStripePaymentMethod[] {
    return EnumStripePaymentMethod.allValues;
  }

  public static getValuesExcept0(): readonly EnumStripePaymentMethod[] {
    return EnumStripePaymentMethod.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStripePaymentMethod {
    const found = EnumStripePaymentMethod.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStripePaymentMethod - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStripePaymentMethod): EnumStripePaymentMethod {
    const found = name ? EnumStripePaymentMethod.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStripePaymentMethod - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStripePaymentMethod>): boolean {
    return this.key === other?.key;
  }
}